import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=6606d096&scoped=true"
import script from "./plans.vue?vue&type=script&lang=js"
export * from "./plans.vue?vue&type=script&lang=js"
import style0 from "./plans.vue?vue&type=style&index=0&id=6606d096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606d096",
  null
  
)

export default component.exports